var map = {
	"./2020-07-15-welcome/index.mdx": 28946,
	"./2020-09-12-augustupdate/index.mdx": 29591,
	"./2020-10-14-productupdate/index.mdx": 70107,
	"./2020-12-01-productupdate/index.mdx": 91899,
	"./2021-01-18-january/index.mdx": 24009,
	"./2021-04-25-april/index.mdx": 85482,
	"./2021-09-01-sept/index.mdx": 91654,
	"./2021-11-07-nov/index.mdx": 70761,
	"src/pages/blog/2020-07-15-welcome/index.mdx": 28946,
	"src/pages/blog/2020-09-12-augustupdate/index.mdx": 29591,
	"src/pages/blog/2020-10-14-productupdate/index.mdx": 70107,
	"src/pages/blog/2020-12-01-productupdate/index.mdx": 91899,
	"src/pages/blog/2021-01-18-january/index.mdx": 24009,
	"src/pages/blog/2021-04-25-april/index.mdx": 85482,
	"src/pages/blog/2021-09-01-sept/index.mdx": 91654,
	"src/pages/blog/2021-11-07-nov/index.mdx": 70761
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35316;